export const NO_RESULTS_FROUND_MESSAGE = 'Oh! No search results found in your files';
export const EXAMPLE_OF_DOSSIER_FORMATS_MESSAGE = 'Supported formats:';
export const NUMBER_OF_RECENT_DOSSIERS_DISPLAYED = 3;
export const DOSSIER_ITEMS_LOCAL_STORAGE_KEY = 'dossierInputRecentItems';
